module.exports = __webpack_public_path__ + "static/media/working-capital.762215cf.png";